import { useEffect, useState } from "react";

import { ICartItem, RefillTooSoonReason } from "common/types/carts";

import Select from "client/common/components/inputs/Select";
import { useCartItemUpdateMutationV2 } from "client/carts/hooks";
import FetchErrorAlert from "client/common/components/errors/FetchErrorAlert";
import { useCurrentDrawer } from "client/common/hooks/stackables";
import DrawerLayout from "client/common/components/stackables/DrawerLayout";

import { refillTooSoonOptions } from "../constants";

export type RefillTooSoonDrawerProps = {
  cartId: number;
  cartItem: ICartItem;
};

const RefillTooSoonDrawer = ({ cartId, cartItem }: RefillTooSoonDrawerProps) => {
  const { close } = useCurrentDrawer();
  const [reason, setReason] = useState<RefillTooSoonReason | null>(
    cartItem.refill_too_soon_reason ?? null,
  );

  const {
    mutate: updateCartItem,
    isLoading: isUpdatingCartItem,
    error: updateCartItemError,
  } = useCartItemUpdateMutationV2(cartItem.id, cartId, { onSuccess: close });

  useEffect(() => {
    setReason(cartItem.refill_too_soon_reason ?? null);
  }, [cartItem.refill_too_soon_reason]);

  return (
    <DrawerLayout>
      <DrawerLayout.Header
        title="Select special cirumstance"
        description={
          <div>
            Early refills may be fulfilled for special circumstances only. If any of the following
            situations applies to you, please select and submit to place order. If not, please exit
            and remove item from cart.
          </div>
        }
        onClose={close}
      />
      {updateCartItemError && (
        <FetchErrorAlert
          error={updateCartItemError}
          fieldErrors={[updateCartItemError.errors.refill_too_soon_reason]}
        />
      )}
      <DrawerLayout.Content>
        <Select
          label="Special circumstance"
          value={reason ?? ""}
          onChange={(val) => setReason(val as RefillTooSoonReason)}
        >
          {Object.entries(refillTooSoonOptions).map(([val, label]) => (
            <Select.Option key={val} value={val}>
              {label}
            </Select.Option>
          ))}
        </Select>
      </DrawerLayout.Content>
      <DrawerLayout.Actions>
        <DrawerLayout.Actions.Button onClick={close} variant="secondary">
          Close
        </DrawerLayout.Actions.Button>
        <DrawerLayout.Actions.Button
          isLoading={isUpdatingCartItem}
          disabled={!reason}
          onClick={() => updateCartItem({ body: { refill_too_soon_reason: reason } })}
        >
          Submit
        </DrawerLayout.Actions.Button>
      </DrawerLayout.Actions>
    </DrawerLayout>
  );
};

export default RefillTooSoonDrawer;
